"use strict";
/**
 * This file was auto-generated by Fern from our API Definition.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.Bcp47Tag = void 0;
exports.Bcp47Tag = {
    Zh: "zh",
    Da: "da",
    Nl: "nl",
    En: "en",
    EnAu: "en-AU",
    EnIn: "en-IN",
    EnNz: "en-NZ",
    EnGb: "en-GB",
    Fr: "fr",
    FrCa: "fr-CA",
    De: "de",
    Hi: "hi",
    HiLatn: "hi-Latn",
    Id: "id",
    It: "it",
    Ja: "ja",
    Ko: "ko",
    No: "no",
    Pl: "pl",
    Pt: "pt",
    PtBr: "pt-BR",
    PtPt: "pt-PT",
    Ru: "ru",
    Es: "es",
    Es419: "es-419",
    Sv: "sv",
    Ta: "ta",
    Tr: "tr",
    Uk: "uk",
};
